import { AssetTransactionTypeEnum, type AssetTransactionTypeEnum as AssetTransactionTypeEnumType } from '@talos/kyoko';
import { EXCLUDED_ADJUST_POSITION_TYPES } from '../BalancesV2/assetTransactionTypeOptions';

/** Types that may be changed away from (backend `assetTransactionAllowedTypeChanges`). */
export const TYPE_CHANGE_SOURCE_TYPES = [
  AssetTransactionTypeEnum.ReconAdjustment,
  AssetTransactionTypeEnum.Misc,
  AssetTransactionTypeEnum.MiscFee,
] as const satisfies readonly AssetTransactionTypeEnumType[];

const TYPE_CHANGE_SOURCE_SET = new Set<AssetTransactionTypeEnumType>(TYPE_CHANGE_SOURCE_TYPES);

const EXCLUDED_DESTINATION_TYPES_SET = new Set<AssetTransactionTypeEnumType>(EXCLUDED_ADJUST_POSITION_TYPES);

/** User-creatable destination types (matches backend `UserCreatableAssetTransactionTypes`). */
export const TYPE_CHANGE_DESTINATION_OPTIONS = (
  Object.values(AssetTransactionTypeEnum) as AssetTransactionTypeEnumType[]
).filter(type => !EXCLUDED_DESTINATION_TYPES_SET.has(type));

export function isAssetTransactionTypeEditable(type: AssetTransactionTypeEnumType | undefined): boolean {
  return type != null && TYPE_CHANGE_SOURCE_SET.has(type);
}
